
import { Component, Vue } from 'vue-property-decorator'

import promotionCodeModule from '@/store/promotion-code'

import ContentList from '@/components/listView/ContentList.vue'
import PromotionCodeEditor from '@/components/promotion-code/PromotionCodeEditor.vue'
import { ListType } from '@/utils/enums'
import { PromotionCode } from '../../types/PromotionCode'

@Component({
  name: 'PromotionCodeList',
  components: {
    ContentList,
    PromotionCodeEditor
  }
})
class PromotionCodeList extends Vue {
  private listType = ListType
  private showEditor = false

  private get storeModule() {
    return promotionCodeModule
  }

  private get promotionCodes(): PromotionCode[] {
    return promotionCodeModule.promotionCodes
  }

  private get headers() {
    return [
      { text: 'Name', value: 'name' },
      { text: 'Code', value: 'code' },
      { text: 'Punkte', value: 'points' },
      { text: 'Startdatum', value: 'startDate' },
      { text: 'Enddatum', value: 'endDate' },
      { text: 'Status', value: 'enable' }
    ]
  }

  private setPromotionCode(promotionCode: PromotionCode): void {
    promotionCodeModule.setPromotionCode(promotionCode)
    ;(this.$refs.promotionCodeDialog as any).toggleDialog()
  }
}

export default PromotionCodeList
